import mod from "-!./Header.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Header.js?vue&type=script&lang=js&"